import { useTheme } from 'foundations-theming-specialty/utils';
import styled, { css } from 'styled-components';
import { ExternalLinkIcon } from '../../../nav-ui-components/Icons/ExternalLink';
import { LINKS } from '../constants/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledExternalLinkIcon = styled(ExternalLinkIcon).withConfig({
  displayName: "KBLink__StyledExternalLinkIcon",
  componentId: "sc-1cyy4f7-0"
})(["margin-bottom:0px !important;width:10px !important;height:10px !important;"]);
const StyledLink = styled.a.withConfig({
  displayName: "KBLink__StyledLink",
  componentId: "sc-1cyy4f7-1"
})(({
  theme
}) => css(["background:none;border:none;padding:0;cursor:pointer;display:flex;align-items:center;gap:", ";transition:text-decoration 0.2s ease;&:hover{text-decoration:underline;}"], theme.space['100']));
const StyledLinkText = styled.span.withConfig({
  displayName: "KBLink__StyledLinkText",
  componentId: "sc-1cyy4f7-2"
})(({
  theme
}) => css(["display:inline-flex;align-items:center;", " color:", ";"], theme.typography['detail-100'], theme.color['text-core-default']));

/**
 * Link to the Deploy Considerations KB article.
 */
export function KBLink() {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(StyledLink, {
    href: LINKS.deployConsiderations,
    target: "_blank",
    rel: "noopener noreferrer",
    "data-test-id": "deploy-considerations-link",
    children: /*#__PURE__*/_jsxs(StyledLinkText, {
      children: ["Deploy considerations", /*#__PURE__*/_jsx(StyledExternalLinkIcon, {
        fill: theme.color['text-core-default']
      })]
    })
  });
}